<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'agro-cultivar') {
            next({ name: 'agro-cultivar-list' });
        } else if (to.name == 'ven-cultivar') {
            next({ name: 'ven-cultivar-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'agro-cultivar') {
            this.$router.push({ name: 'agro-cultivar-list' });
        } else if (this.$route.name == 'ven-cultivar') {
            this.$router.push({ name: 'ven-cultivar-list' });
        }
    },
};
</script>
